import cx from 'classnames'

import {
  alignmentStyles,
  styles,
  typeStyles,
  variantStyles,
} from './table-cell.styles'
import type { TableCellProps } from './table-cell.types'

export function TableCell(props: TableCellProps) {
  const {
    as = 'td',
    align = 'left',
    type = 'text',
    variant = 'page',
    className = '',
    ...htmlProps
  } = props

  const Component = as

  return (
    <Component
      className={cx(
        styles.base,
        alignmentStyles[align],
        typeStyles[type],
        variantStyles[variant],
        className,
      )}
      {...htmlProps}
    />
  )
}
